import appLocaleData from 'react-intl/locale-data/ar';

const saLang = {
    messages: {},
    locale: 'ar-SA',
    data: appLocaleData,
};
export default saLang;
